import Swiper from 'swiper';
import 'swiper/css';
import { Mousewheel, Keyboard } from 'swiper/modules';

const swiperPricingSections = document.querySelectorAll('section.pricing-block .swiper');

if (swiperPricingSections.length) {
    swiperPricingSections.forEach(swiperPricingContainer => {
    const breakpoint = window.matchMedia('(min-width: 1100px)');
    let swiperInstance = null;

    const enableSwiper = () => {
      swiperInstance = new Swiper(swiperPricingContainer, {
        modules: [Mousewheel, Keyboard],
        direction: 'horizontal',
        spaceBetween: 15,
        slidesPerView: 1.2,
        slidesOffsetAfter: 20,

        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
        },

        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },

        breakpoints: {
          600: {
            slidesPerView: 1.5,
            spaceBetween: 25,
          },
          700: {
            slidesPerView: 1.7,
          },
          800: {
            slidesPerView: 2.2,
          },
        },
      });
    };

    const destroySwiper = () => {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    };

    const toggleSwiper = () => {
      if (breakpoint.matches) {
        destroySwiper();
      } else {
        enableSwiper();
      }
    };

    toggleSwiper();
    breakpoint.addEventListener('change', toggleSwiper);
  });
}

function equalizeMembershipCardHeights() {
  const slides = document.querySelectorAll('section.memberships .swiper-slide');

  // Reset heights first
  slides.forEach(slide => slide.style.height = 'auto');

  // Get the tallest height within the memberships swiper
  const maxHeight = Math.max(...Array.from(slides).map(slide => slide.offsetHeight));

  // Apply the max height to all
  slides.forEach(slide => slide.style.height = `${maxHeight}px`);
}


document.addEventListener('DOMContentLoaded', equalizeMembershipCardHeights);
window.addEventListener('resize', () => {
  clearTimeout(window._membershipResizeTimeout);
  window._membershipResizeTimeout = setTimeout(equalizeMembershipCardHeights, 100);
});

// Run on DOM load
document.addEventListener('DOMContentLoaded', equalizeCardHeights);


